import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MeetingSummaryResult } from '../../../../models/nova-voice.model';

@Component({
  selector: 'nova-coaching',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  templateUrl: './coaching.component.html',
  styleUrls: ['./coaching.component.scss'],
})
export class NovaCoachingComponent {
  @Input() data: MeetingSummaryResult;
  @Input() isProcessing: boolean = false;

  get performancePercent(): number {
    const raw = (this.data?.coaching_tips?.overall_performance_score ?? 0) * 100;
    return Math.min(100, Math.max(0, Math.round(raw)));
  }

  get confidencePercent(): number {
    const raw = (this.data?.confidence_score ?? 0) * 100;
    return Math.min(100, Math.max(0, Math.round(raw)));
  }

  getSentimentPct(value: number | undefined): number {
    return Math.min(100, Math.max(0, value ?? 0));
  }

  getScoreRingStyle(): string {
    const pct = this.performancePercent;
    const color = pct >= 80 ? 'var(--nova-accent)' : pct >= 60 ? 'var(--nova-warning)' : 'var(--nova-danger)';
    return `conic-gradient(${color} ${pct}%, var(--nova-border) ${pct}%)`;
  }

  getConfidenceRingStyle(): string {
    const pct = this.confidencePercent;
    return `conic-gradient(var(--nova-accent-secondary) ${pct}%, var(--nova-border) ${pct}%)`;
  }
}
